module.exports = __webpack_public_path__ + "static/media/coffee_video_featured.7c8e266d.jpg";